/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Promotion_WeeksInputs */

const en_directory_promotion_weeks = /** @type {(inputs: Directory_Promotion_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} weeks`)
};

const zh_directory_promotion_weeks = /** @type {(inputs: Directory_Promotion_WeeksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 周`)
};

/**
* | output |
* | --- |
* | "{count} weeks" |
*
* @param {Directory_Promotion_WeeksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_weeks = /** @type {((inputs: Directory_Promotion_WeeksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_WeeksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_weeks(inputs)
	return zh_directory_promotion_weeks(inputs)
});
export { directory_promotion_weeks as "directory.promotion.weeks" }